import { useMemo, useState } from 'react';
import { Select } from 'antd';
import dayjs from 'dayjs';
import {
    activityLevel, activityMonthLabels, activitySummary, activityTooltip, activityYears, buildActivityWeeks,
} from './task-activity';
import './task-activity.css';

const DOW = ['', 'Пн', '', 'Ср', '', 'Пт', ''];

const TaskActivity = ({ days, onDayClick }) => {
    const years = useMemo(() => activityYears(days), [days]);
    const [year, setYear] = useState(() => dayjs().year());
    const selected = years.includes(year) ? year : years[0];
    const rolling = selected === dayjs().year();
    const { weeks, max, total } = useMemo(() => buildActivityWeeks(days, selected), [days, selected]);
    const months = useMemo(() => activityMonthLabels(weeks), [weeks]);

    return (
        <div className="task-activity">
            <div className="task-activity-head">
                <span>{activitySummary(total, selected, rolling)}</span>
                <span className="task-activity-tools">
                    <span className="task-activity-legend">
                        Меньше
                        {[0, 1, 2, 3, 4].map((level) => (
                            <i key={level} className={`task-activity-cell l${level}`} />
                        ))}
                        Больше
                    </span>
                    <Select
                        className="task-activity-year"
                        size="small"
                        value={selected}
                        onChange={setYear}
                        options={years.map((item) => ({ value: item, label: String(item) }))}
                        popupMatchSelectWidth={false}
                        aria-label="Год"
                    />
                </span>
            </div>
            <div className="task-activity-scroll">
                <div className="task-activity-dows">
                    {DOW.map((label, index) => <span key={index}>{label}</span>)}
                </div>
                <div>
                    <div className="task-activity-months">
                        {months.map((label, index) => <span key={index}>{label}</span>)}
                    </div>
                    <div className="task-activity-weeks">
                        {weeks.map((week) => (
                            <div className="task-activity-week" key={week[0].key}>
                                {week.map((cell) => (
                                    <button
                                        key={cell.key}
                                        type="button"
                                        className={`task-activity-cell${cell.future ? ' future' : ` l${activityLevel(cell.count, max)}`}`}
                                        title={cell.future ? undefined : activityTooltip(cell.count, cell.date)}
                                        aria-label={cell.future ? undefined : activityTooltip(cell.count, cell.date)}
                                        disabled={cell.future || !onDayClick}
                                        onClick={() => onDayClick?.(cell)}
                                    />
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaskActivity;
